import { render, staticRenderFns } from "./DropdownMenuLink.vue?vue&type=template&id=082c36f0"
import script from "./DropdownMenuLink.vue?vue&type=script&lang=js"
export * from "./DropdownMenuLink.vue?vue&type=script&lang=js"
import style0 from "./DropdownMenuLink.vue?vue&type=style&index=0&id=082c36f0&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports